import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'

import Form, { FormContent } from '../../components/form/Form'
import { adressInfoForm } from '../../formDefinitions/AddressInfoForm/AddressInfoForm'
import { AdditionalFormNames, AllAdditionalFieldsNames, AllBasedFieldsNames, FormNames, TAllAdditionalFieldsNames } from '../../models/form/IFormDefinition'
import { apphistory, AppState } from '../../store'
import { correspondenceAdressInfoForm } from '../../formDefinitions/AddressInfoForm/CorrespondenceAddressInfoForms'
import { TOGGLE_ADDITIONAL_FROM } from '../../store/actions/form-actions'
import Switch from '../../components/form/Switch/Switch'
import useFormLogic from '../../components/form/hooks/useFormLogic'
import { TFieldValuesObject } from '../../components/form/FormProps'
import PageScreen from "../../components/organisms/Page/PageScreen";
import {AppLinks} from "../../environment/app-links";
import useTextContents from "../../hooks/useTextContents";
import LoanOfferSummaryPanel from '../../components/organisms/LoanOfferSummaryPanel/LoanOfferSummaryPanel'


const CorrespondenceAddressAdditionalForm = () => {
   const correspondenceAddressFormState = useSelector((state: AppState) => state.formState[AdditionalFormNames.CorrespondenceAddressForm])

   if(correspondenceAddressFormState === undefined){
      return null
   }

   return (
      <FormContent
         fields={correspondenceAdressInfoForm.additionalFields}
         formName={correspondenceAdressInfoForm.name}
         formLabel={correspondenceAdressInfoForm.label}
         fieldsState={correspondenceAddressFormState.fieldsData}  // This will always get the most up-to-date fieldsData
         formValidationFunctions={correspondenceAdressInfoForm.formValidationFunctions}
      />
   )
}

const AddressInfoForm = () => {
   const formState = useSelector((state: AppState) => state.formState)
   const [showAdditionalForm, setShowAdditionalForm] = useState<boolean>(formState.globalFormConfig.currentOpenedAdditionalForms.includes(AdditionalFormNames.CorrespondenceAddressForm))
   const dispatch = useDispatch()
   const { handleValidateForm } = useFormLogic()
    const textContents = useTextContents()

    const handleOnAddressInfoFormSubmit = useCallback((fieldValuesObject :TFieldValuesObject<Partial<typeof AllBasedFieldsNames>> | TFieldValuesObject<Partial<typeof AllAdditionalFieldsNames>>) => {
      const basicFormSubmitResult = handleValidateForm({ formName: adressInfoForm.name, fieldValuesObject, formValidationFunctionsObject: adressInfoForm.formValidationFunctions })

      const additionalFormSubmitResult = showAdditionalForm ? // Jeśli dodatkowy formularz otwarty - walidujemy również go
         handleValidateForm({
            formName: correspondenceAdressInfoForm.name,
            fieldValuesObject,
            formValidationFunctionsObject: correspondenceAdressInfoForm.formValidationFunctions,
        })
      : true

      basicFormSubmitResult && additionalFormSubmitResult && adressInfoForm.nextFormUrlPath && apphistory.push(adressInfoForm.nextFormUrlPath)
   }, [handleValidateForm, showAdditionalForm])



    const handleBackClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        apphistory.push(AppLinks.extendedInfoForm)
    }

    return (

       <PageScreen
           title={{title: "Adres zamieszkania", line: true}}
           panel={<LoanOfferSummaryPanel loanVariant="predefined" />}
           showBackButton={true}
           onClickBack={handleBackClick}
       >
           <Form
               fields={adressInfoForm.fields}
               form={adressInfoForm}
               formState={formState[FormNames.AddressInfoForm]}
               onFormSubmit={handleOnAddressInfoFormSubmit}
           >
               <Switch
                   dataTestId="correspondence-address-form-switch"
                   isChecked={showAdditionalForm}
                   handleOnSwitch={() => {
                       dispatch({
                           type: TOGGLE_ADDITIONAL_FROM,
                           payload: {
                               formName: correspondenceAdressInfoForm.name,
                               isAdditionalFormOpen: !showAdditionalForm,
                               additionalFieldsNamesToAdd: Object.keys(correspondenceAdressInfoForm.additionalFields) as TAllAdditionalFieldsNames[]
                           }
                       })

                       setShowAdditionalForm(!showAdditionalForm)
                   }}
                   label={correspondenceAdressInfoForm.switchLabel}
                   additionalFormName={correspondenceAdressInfoForm.name}
               />
               {
                   showAdditionalForm &&
                   <CorrespondenceAddressAdditionalForm />
               }
           </Form>
       </PageScreen>

   )
}

export default AddressInfoForm